export default __webpack_public_path__ + "static/media/Cluster-Icon.d86a1b52.svg";